import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getDefaultStyleSheet = _ref => {
  var {
    borderColorToken,
    borderColorTokenArgs,
    designContext,
    disabled,
    framed,
    hasBorder,
    horizontalPaddingToken,
    minHeight,
    UNSAFE_style,
    verticalPaddingToken
  } = _ref;
  var deprecatedColorTokenExists = designContext.hasTokenInContext('item-information/border-color');
  var framingVariant = framed ? 'framed' : 'default';
  var itemCornerRadius = designContext.get('item-information/corner-radius', {
    framingVariant
  }).value();
  var backgroundColor = designContext.get('item-information/background-color', {
    framingVariant
  }).toString();
  var itemSidePadding = designContext.get(horizontalPaddingToken, {
    framingVariant
  }).value();
  var itemTopBottomSpacer = designContext.get(verticalPaddingToken).value();
  var itemVerticalGapSpacer = designContext.get('space/200').value();
  var itemHorizontalGapSpacer = designContext.get('space/150').value();
  var borderWidth = framed && (hasBorder || borderColorToken) ? designContext.get('item-information/border-width').value() : 0;
  var _ref2 = UNSAFE_style || {},
    {
      borderLeftWidth: UNSAFE_borderLeftWidth,
      borderRightWidth: UNSAFE_borderRightWidth,
      borderTopWidth: UNSAFE_borderTopWidth,
      borderBottomWidth: UNSAFE_borderBottomWidth
    } = _ref2,
    cleanUNSAFE_style = _objectWithoutProperties(_ref2, _excluded);
  var borderLeftWidth = typeof UNSAFE_borderLeftWidth === 'number' ? UNSAFE_borderLeftWidth : borderWidth;
  var borderRightWidth = typeof UNSAFE_borderRightWidth === 'number' ? UNSAFE_borderRightWidth : borderWidth;
  var borderTopWidth = typeof UNSAFE_borderTopWidth === 'number' ? UNSAFE_borderTopWidth : borderWidth;
  var borderBottomWidth = typeof UNSAFE_borderBottomWidth === 'number' ? UNSAFE_borderBottomWidth : borderWidth;
  return {
    wrapperA: _objectSpread({
      backgroundColor,
      borderColor: designContext.get(borderColorToken || (deprecatedColorTokenExists ? 'item-information/border-color' : 'colors/borders/subtle-floating'), _objectSpread({
        interactiveState: disabled ? 'disabled' : undefined
      }, borderColorTokenArgs)).toString(),
      borderLeftWidth,
      borderRightWidth,
      borderTopWidth,
      borderBottomWidth,
      paddingTop: itemTopBottomSpacer - borderTopWidth,
      paddingBottom: itemTopBottomSpacer - borderBottomWidth,
      paddingRight: itemSidePadding - borderRightWidth,
      paddingLeft: itemSidePadding - borderLeftWidth,
      borderRadius: itemCornerRadius,
      minHeight,
      justifyContent: 'center'
    }, cleanUNSAFE_style),
    wrapperB: {
      opacity: disabled ? 0.5 : 1,
      flexDirection: 'row',
      flexBasis: 'auto',
      gap: itemVerticalGapSpacer
    },
    wrapperC: {
      flexGrow: 1,
      flexShrink: 1,
      flexDirection: 'column',
      gap: itemHorizontalGapSpacer,
      alignSelf: 'center'
    },
    wrapperD: {
      flexBasis: 'auto',
      flexDirection: 'row',
      gap: itemVerticalGapSpacer
    },
    wrapperE: {
      flexDirection: 'column',
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: 'center'
    },
    wrapperF: {
      gap: 2
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map